import { useState } from "react";
import { message } from "antd";
import { generateInvoiceLinkApi, sendInvoiceEmailApi } from "../apiservice/setting";

export const useShareDocument = () => {
  const [shareOpen, setShareOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const generateLink = async ({ url, fileName }) => {
    const res = await generateInvoiceLinkApi({ url, fileName });
    return res?.data?.url;
  };

  const sendEmail = async ({ email, name, docNo, url }) => {
    await sendInvoiceEmailApi({
      email,
      name,
      invoiceNo: docNo,
      url,
    });
  };

  const handleEmailShare = async ({ url, fileName, name, docNo }) => {
    try {
      setLoading(true);
      const generatedUrl = await generateLink({ url, fileName });

      await sendEmail({
        email,
        name,
        docNo,
        url: generatedUrl,
      });

      message.success("Document emailed successfully");
      setShareOpen(false);
      setEmail("");
    } catch (err) {
      console.error(err);
      message.error("Failed to send email");
    } finally {
      setLoading(false);
    }
  };

  const handleWhatsAppShare = async ({ url, fileName, text }) => {
    if (loading) return;
    try {
      setLoading(true);
      const generatedUrl = await generateLink({ url, fileName });
      const finalText = `${text} ${generatedUrl}`;
      const waUrl = `https://wa.me/?text=${encodeURIComponent(finalText)}`;
      if (newWindow) {
        newWindow.location.href = waUrl;
      } else {
        window.open(waUrl, "_blank");
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to share");
    } finally {
      setLoading(false);
    }
  };

  return {
    shareOpen,
    setShareOpen,
    email,
    setEmail,
    loading,
    handleEmailShare,
    handleWhatsAppShare,
  };
};
